import { Grid, IconButton, Tooltip } from "@material-ui/core";
import { observer } from "mobx-react";
import React, { memo } from "react";
import { formatMoney, getDateTime, getTimeDate, hideMiddleDigits, isAdmin, isRoleBranchManager, isRoleCashier, isRoleHisReadOnly } from "app/common/LocalFunction";
import { useTranslation } from "react-i18next";
import { RELATIONSHIP_TYPES } from "app/common/LocalConst";
import { useHistory } from "react-router-dom";
import { Add } from "@material-ui/icons";
import { useStore } from "app/stores";
import PopupRalationShip from "./Popup/PopupRalationShip";
import IconDelete from "app/common/Icon/IconDelete";
import ConfirmPopup from "app/common/Component/Popup/ConfirmPopup";
const ListRelationshipBlock = ({
  initialPatient,
  setCurrentTab,
}) => {
  const { t } = useTranslation();
  const history = useHistory();
  const { 
    handlePopupRalationShip,
    openPopupRalationShip,
    handleClosePopupRalationShip,
    openConfirmDeleteRelationship,
    handleOpenConfirmDeleteRelationship,
    handleDeleteRelationship
    } 
    =useStore().patientManagementStore.patientGeneralStore;
    const isReadonly = isRoleHisReadOnly()
    const isRoleBranchManagers = isRoleBranchManager()
    const isRoleCashiers = isRoleCashier()
    const isadmins = isAdmin()
  return (
    <div style={{ backgroundColor: "aliceblue", height: "100%",boxShadow: "0 8px 24px rgba(0, 0, 0, 0.08)" }}>
        <Grid
            container
            spacing={1}
            className="m-0 w-100"
            style={{ backgroundColor: "aliceblue" }}
        >
            <Grid
                item
                sm={12}
                className="search-title-card"
                style={{ width: "100%" }}
            >
                <p className="title-block">Quan hệ</p>
                <div className="flex align-center flex-end gap-1 cursor">
                {!isReadonly && (
                    <>
                        <Tooltip  title="Thêm mối quan hệ">
                        <IconButton
                        size="small"
                        style={{ color: "#eb7d15" }}
                        onClick={() => handlePopupRalationShip(true)}
                        >
                            <Add className="font-md" />
                            </IconButton>
                        </Tooltip>
                        <p
                            className="button-more"
                        >
                            Thêm mối quan hệ
                        </p>
                    </>
                )}
                
                </div>
            </Grid>
            <Grid item xs={12}>
                {(initialPatient?.relatedPersons || []).map((item, index) => {
                    const related = item?.relatedPatient || {};
                    const relationshipName =
                        RELATIONSHIP_TYPES.find(r => r.value === item.relationship)?.name || 'Không xác định';

                    return (
                        <div key={index} style={{ borderBottom: "1px solid gray", display: "flex", justifyContent: "space-between" }}>
                            <div  
                                onClick={() => {
                                    history.push(
                                        `/patient-management/patient-general?patientId=${item?.relatedPatient?.id}`
                                    );
                                }} 
                                style={{ padding: '10px' }}
                            >
                                <div className="flex gap-2 items-center">
                                    <span style={{
                                        fontSize: "var(--fs-base)",
                                        fontWeight: 600,
                                        paddingBottom: "2px"
                                    }}>
                                        {relationshipName}
                                    </span>
                                    <span style={{
                                        fontSize: "var(--fs-base)",
                                        fontWeight: 600,
                                        color: "#666",
                                        paddingBottom: "2px",
                                    }}>
                                        {related?.code || ''}
                                    </span>
                                </div>
                                <div style={{ display: 'flex', marginTop: '8px', fontSize: "var(--fs-base)", color: '#333', gap:"5px" }}>
                                    <div style={{ fontWeight: '600',cursor: "pointer" }}>{related?.displayName || 'Không có tên'}</div>
                                        {related?.phoneNumber && (
                                            <div style={{ fontSize: "var(--fs-base)", color: '#666'}}>
                                                {hideMiddleDigits(related.phoneNumber)}
                                            </div>
                                        )}
                                    </div>
                                <div style={{ fontSize: "var(--fs-base)", marginTop: '4px' }}>
                                    Lần đi cùng gần nhất: <b>{getTimeDate(item.lastCompanionDate)}</b>
                                </div>
                            </div>
                            <div className="flex justify-center items-center p-2 gap-4">
                                {!isReadonly && (isadmins || isRoleBranchManagers || isRoleCashiers) && (
                                    <>
                                        <Tooltip title="Xóa mối quan hệ">
                                            <div
                                            className="flex"
                                            onClick={() =>
                                                handleOpenConfirmDeleteRelationship(item?.id)
                                            }
                                            >
                                            <IconDelete />
                                            </div>
                                        </Tooltip>
                                    </>
                                )}
                            </div>
                        </div>
                    );
                })}
            </Grid>
        </Grid>
        {openPopupRalationShip && (
            <PopupRalationShip
                open={openPopupRalationShip}
                handleClose={handleClosePopupRalationShip}
            />
        )}
        {openConfirmDeleteRelationship && (
            <ConfirmPopup
                open={!!openConfirmDeleteRelationship}
                onClose={() => handleOpenConfirmDeleteRelationship(null)}
                text="Bạn có chắc chắn muốn xóa mối quan hệ này không?"
                onConfirm={handleDeleteRelationship}
            />
        )}
    </div>
    );
};

export default memo(observer(ListRelationshipBlock));
